import React, { useState, useEffect, useCallback } from "react";
import { db } from '../config/firebaseConfig';
import { collection, addDoc, getDocs, updateDoc, deleteDoc, doc } from "firebase/firestore";
import { Container, Form, Button, Table, Dropdown, Badge, Modal, Row, Col, OverlayTrigger, Tooltip } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import ReactPaginate from 'react-paginate';
import { FaAngleLeft, FaAngleRight } from 'react-icons/fa';

const Gundemler = () => {
  const [gundemler, setGundemler] = useState([]);
  const [yeniGundem, setYeniGundem] = useState("");
  const [yeniNot, setYeniNot] = useState("");
  const [yeniBrans, setYeniBrans] = useState("");
  const [baslangicTarihi, setBaslangicTarihi] = useState(new Date());
  const [bitisTarihi, setBitisTarihi] = useState(new Date());
  const [arama, setArama] = useState("");
  const [filtreDurum, setFiltreDurum] = useState("");
  const [filtreBrans, setFiltreBrans] = useState("");
  const [duzenlenecekGundem, setDuzenlenecekGundem] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showNotModal, setShowNotModal] = useState(false);
  const [seciliNot, setSeciliNot] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  
  const MAX_BASLIK_UZUNLUK = 50;
  const itemsPerPage = 15;

  const getWeekStart = (date) => {
    const d = new Date(date);
    const day = d.getDay();
    const diff = d.getDate() - day + (day === 0 ? -6 : 1);
    return new Date(d.setDate(diff));
  };

  const fetchGundemler = useCallback(async () => {
    try {
      const gundemCollection = collection(db, "gundemler");
      const gundemSnapshot = await getDocs(gundemCollection);
      let gundemList = gundemSnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      const weekStart = getWeekStart(new Date());
      gundemList = gundemList.filter((gundem) => {
        const gundemTarihi = new Date(gundem.baslangicTarihi || gundem.eklenmeTarihi || new Date());
        const gundemDateOnly = new Date(gundemTarihi.getFullYear(), gundemTarihi.getMonth(), gundemTarihi.getDate());
        const weekStartDateOnly = new Date(weekStart.getFullYear(), weekStart.getMonth(), weekStart.getDate());
        return gundemDateOnly >= weekStartDateOnly;
      });

      gundemList.sort((a, b) => new Date(b.eklenmeTarihi) - new Date(a.eklenmeTarihi));
      setGundemler(gundemList);
      setCurrentPage(0); // Filtre değiştiğinde sayfayı sıfırla
    } catch (error) {
      console.error("Veri çekme hatası:", error);
    }
  }, []); // Removed [db] dependency

  useEffect(() => {
    fetchGundemler();
  }, [fetchGundemler]);

  const handleAddGundem = async (e) => {
    e.preventDefault();
    if (!yeniGundem) return;

    const newGundem = {
      baslik: yeniGundem.length > MAX_BASLIK_UZUNLUK ? yeniGundem.substring(0, MAX_BASLIK_UZUNLUK) + "..." : yeniGundem,
      durum: "Başlanmadı",
      not: yeniNot,
      brans: yeniBrans,
      baslangicTarihi: baslangicTarihi.toISOString(),
      bitisTarihi: bitisTarihi.toISOString(),
      eklenmeTarihi: new Date().toISOString(),
    };

    try {
      await addDoc(collection(db, "gundemler"), newGundem);
      setYeniGundem("");
      setYeniNot("");
      setYeniBrans("");
      setBaslangicTarihi(new Date());
      setBitisTarihi(new Date());
      await fetchGundemler();
    } catch (error) {
      console.error("Gündem ekleme hatası:", error);
    }
  };

  const handleDurumChange = async (id, yeniDurum) => {
    try {
      const gundemDoc = doc(db, "gundemler", id);
      await updateDoc(gundemDoc, { durum: yeniDurum });
      await fetchGundemler();
    } catch (error) {
      console.error("Durum güncelleme hatası:", error);
    }
  };

  const handleDelete = async (id) => {
    try {
      await deleteDoc(doc(db, "gundemler", id));
      await fetchGundemler();
    } catch (error) {
      console.error("Silme hatası:", error);
    }
  };

  const handleEdit = (gundem) => {
    setDuzenlenecekGundem(gundem);
    setShowModal(true);
  };

  const handleNotGoster = (not) => {
    setSeciliNot(not);
    setShowNotModal(true);
  };

  const handleModalSave = async () => {
    try {
      const gundemDoc = doc(db, "gundemler", duzenlenecekGundem.id);
      await updateDoc(gundemDoc, {
        baslik: duzenlenecekGundem.baslik,
        not: duzenlenecekGundem.not,
        brans: duzenlenecekGundem.brans,
        baslangicTarihi: new Date(duzenlenecekGundem.baslangicTarihi).toISOString(),
        bitisTarihi: new Date(duzenlenecekGundem.bitisTarihi).toISOString(),
      });
      setShowModal(false);
      await fetchGundemler();
    } catch (error) {
      console.error("Düzenleme hatası:", error);
    }
  };

  const exportToExcel = () => {
    const ws = XLSX.utils.json_to_sheet(filtrelenmisGundemler);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Gundemler");
    XLSX.writeFile(wb, "gundemler.xlsx");
  };

  const exportToPDF = () => {
    const docPDF = new jsPDF();
    const tableColumn = ["Başlık", "Branş", "Durum", "Başlangıç", "Bitiş", "Not"];
    const tableRows = filtrelenmisGundemler.map(g => [
      g.baslik,
      g.brans || "-",
      g.durum,
      new Date(g.baslangicTarihi).toLocaleDateString(),
      new Date(g.bitisTarihi).toLocaleDateString(),
      g.not || "-"
    ]);
    docPDF.autoTable({ head: [tableColumn], body: tableRows });
    docPDF.save("gundemler.pdf");
  };

  const durumRenkleri = {
    "Tamamlanmadı": "bg-danger text-white",
    "Üzerinde Çalışılıyor": "bg-warning text-dark",
    "Başlanmadı": "bg-secondary text-white",
    "Tamamlandı": "bg-success text-white",
  };

  const filtrelenmisGundemler = gundemler.filter((gundem) => {
    const baslikMatch = gundem.baslik.toLowerCase().includes(arama.toLowerCase());
    const durumMatch = filtreDurum ? gundem.durum === filtreDurum : true;
    const bransMatch = filtreBrans ? gundem.brans === filtreBrans : true;
    return baslikMatch && durumMatch && bransMatch;
  });

  const branslar = [...new Set(gundemler.map(g => g.brans).filter(b => b))];

  // Sayfalama için gündemleri dilimleme
  const offset = currentPage * itemsPerPage;
  const currentGundemler = filtrelenmisGundemler.slice(offset, offset + itemsPerPage);
  const pageCount = Math.ceil(filtrelenmisGundemler.length / itemsPerPage);

  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected);
  };

  return (
    <Container fluid className="mt-3 px-3" style={{ maxWidth: "1200px" }}>
      <h2 
        className="text-center mb-4 position-relative"
        style={{
          color: '#2c3e50',
          fontWeight: '600',
          letterSpacing: '0.5px',
          paddingBottom: '10px'
        }}
      >
        Kocaeli Güneş Ortaokulu <br className="d-md-none" />Haftalık Gündemler
        <span 
          style={{
            display: 'block',
            width: '80px',
            height: '3px',
            background: '#3498db',
            margin: '8px auto 0',
            borderRadius: '3px'
          }}
        ></span>
      </h2>

      <Form onSubmit={handleAddGundem} className="mb-4 p-3 bg-light rounded shadow-sm">
        <Row className="g-3">
          <Col xs={12} md={6}>
            <Form.Group>
              <Form.Label>Gündem Başlığı (Max {MAX_BASLIK_UZUNLUK} karakter)</Form.Label>
              <Form.Control 
                type="text" 
                placeholder="Başlık giriniz" 
                value={yeniGundem} 
                onChange={(e) => setYeniGundem(e.target.value)} 
                maxLength={MAX_BASLIK_UZUNLUK}
                required 
              />
              <small className="text-muted">{yeniGundem.length}/{MAX_BASLIK_UZUNLUK}</small>
            </Form.Group>
          </Col>
          <Col xs={12} md={6}>
            <Form.Group>
              <Form.Label>Branş</Form.Label>
              <Form.Control
                type="text"
                placeholder="Branş giriniz"
                value={yeniBrans}
                onChange={(e) => setYeniBrans(e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col xs={12} md={3}>
            <Form.Group>
              <Form.Label>Başlangıç Tarihi</Form.Label>
              <DatePicker 
                selected={baslangicTarihi} 
                onChange={(date) => setBaslangicTarihi(date)} 
                className="form-control" 
                dateFormat="dd/MM/yyyy" 
                wrapperClassName="w-100"
              />
            </Form.Group>
          </Col>
          <Col xs={12} md={3}>
            <Form.Group>
              <Form.Label>Bitiş Tarihi</Form.Label>
              <DatePicker 
                selected={bitisTarihi} 
                onChange={(date) => setBitisTarihi(date)} 
                className="form-control" 
                dateFormat="dd/MM/yyyy" 
                wrapperClassName="w-100"
              />
            </Form.Group>
          </Col>
          <Col xs={12} md={3}>
            <Form.Group>
              <Form.Label>Not (Opsiyonel)</Form.Label>
              <Form.Control 
                as="textarea" 
                rows={1} 
                placeholder="Not ekleyin" 
                value={yeniNot} 
                onChange={(e) => setYeniNot(e.target.value)} 
              />
            </Form.Group>
          </Col>
          <Col xs={12} md={3} className="d-flex align-items-end">
            <Button variant="primary" type="submit" className="w-100 py-2">Ekle</Button>
          </Col>
        </Row>
      </Form>

      <div className="mb-4 d-flex flex-column flex-md-row justify-content-between align-items-stretch align-items-md-center gap-2">
        <Form.Control 
          type="text" 
          placeholder="Başlık ara..." 
          value={arama} 
          onChange={(e) => setArama(e.target.value)} 
          className="flex-grow-1"
        />
        <div className="d-flex flex-wrap gap-2 justify-content-end">
          <Dropdown>
            <Dropdown.Toggle variant="outline-secondary" className="text-nowrap" size="sm">
              {filtreDurum || "Durum Filtrele"}
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item onClick={() => setFiltreDurum("")}>Tümü</Dropdown.Item>
              <Dropdown.Item onClick={() => setFiltreDurum("Tamamlanmadı")}>Tamamlanmadı</Dropdown.Item>
              <Dropdown.Item onClick={() => setFiltreDurum("Üzerinde Çalışılıyor")}>Üzerinde Çalışılıyor</Dropdown.Item>
              <Dropdown.Item onClick={() => setFiltreDurum("Başlanmadı")}>Başlanmadı</Dropdown.Item>
              <Dropdown.Item onClick={() => setFiltreDurum("Tamamlandı")}>Tamamlandı</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
          <Dropdown>
            <Dropdown.Toggle variant="outline-secondary" className="text-nowrap" size="sm">
              {filtreBrans || "Branş Filtrele"}
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item onClick={() => setFiltreBrans("")}>Tümü</Dropdown.Item>
              {branslar.map((brans, index) => (
                <Dropdown.Item key={index} onClick={() => setFiltreBrans(brans)}>{brans}</Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
          <Button variant="success" onClick={exportToExcel} className="text-nowrap" size="sm">Excel</Button>
          <Button variant="danger" onClick={exportToPDF} className="text-nowrap" size="sm">PDF</Button>
        </div>
      </div>

      {filtrelenmisGundemler.length > 0 ? (
        <>
          <div className="table-responsive">
            <Table striped bordered hover className="mb-3">
              <thead className="bg-dark text-white">
                <tr>
                  <th>#</th>
                  <th>Başlık</th>
                  <th>Branş</th>
                  <th className="text-nowrap">Durum</th>
                  <th className="text-nowrap">Tarih Aralığı</th>
                  <th>Not</th>
                  <th>İşlemler</th>
                </tr>
              </thead>
              <tbody>
                {currentGundemler.map((gundem, index) => (
                  <tr key={gundem.id}>
                    <td>{offset + index + 1}</td>
                    <td>
                      <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip>{gundem.baslik}</Tooltip>}
                      >
                        <span>{gundem.baslik}</span>
                      </OverlayTrigger>
                    </td>
                    <td>{gundem.brans || "-"}</td>
                    <td>
                      <Dropdown>
                        <Dropdown.Toggle 
                          className={`w-100 ${durumRenkleri[gundem.durum]}`} 
                          style={{ border: "none", padding: "0.25rem 0.5rem", fontSize: "0.875rem" }}
                          size="sm"
                        >
                          {gundem.durum}
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          <Dropdown.Item onClick={() => handleDurumChange(gundem.id, "Tamamlanmadı")}>Tamamlanmadı</Dropdown.Item>
                          <Dropdown.Item onClick={() => handleDurumChange(gundem.id, "Üzerinde Çalışılıyor")}>Üzerinde Çalışılıyor</Dropdown.Item>
                          <Dropdown.Item onClick={() => handleDurumChange(gundem.id, "Başlanmadı")}>Başlanmadı</Dropdown.Item>
                          <Dropdown.Item onClick={() => handleDurumChange(gundem.id, "Tamamlandı")}>Tamamlandı</Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </td>
                    <td>
                      <Badge bg="light" text="dark" className="text-nowrap">
                        {new Date(gundem.baslangicTarihi).toLocaleDateString()} - {new Date(gundem.bitisTarihi).toLocaleDateString()}
                      </Badge>
                    </td>
                    <td>
                      {gundem.not ? (
                        <Button 
                          variant="link" 
                          className="p-0 text-decoration-none" 
                          onClick={() => handleNotGoster(gundem.not)}
                          title="Notu görmek için tıklayın"
                        >
                          {gundem.not.length > 30 ? gundem.not.substring(0, 30) + "..." : gundem.not}
                        </Button>
                      ) : (
                        "Not eklenmemiş"
                      )}
                    </td>
                    <td className="text-nowrap">
                      <Button size="sm" variant="warning" className="me-2 mb-1 mb-md-0" onClick={() => handleEdit(gundem)}>Düzenle</Button>
                      <Button size="sm" variant="danger" onClick={() => handleDelete(gundem.id)}>Sil</Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>

          {/* Pagination */}
          {pageCount > 1 && (
            <div className="d-flex justify-content-center mt-3">
              <ReactPaginate
                previousLabel={<FaAngleLeft />}
                nextLabel={<FaAngleRight />}
                breakLabel="..."
                breakClassName="page-item"
                breakLinkClassName="page-link"
                pageCount={pageCount}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                onPageChange={handlePageClick}
                containerClassName="pagination"
                pageClassName="page-item"
                pageLinkClassName="page-link"
                previousClassName="page-item"
                previousLinkClassName="page-link"
                nextClassName="page-item"
                nextLinkClassName="page-link"
                activeClassName="active"
                forcePage={currentPage}
              />
            </div>
          )}

          <div className="text-muted text-center mt-2">
            Toplam {filtrelenmisGundemler.length} gündem ({currentPage + 1}. sayfa, {currentGundemler.length} gösteriliyor)
          </div>
        </>
      ) : (
        <p className="text-center mt-4">Bu hafta için gündem bulunmamaktadır.</p>
      )}
      <div className="powered-by-section">
        <p>
          Powered by <a href="https://hacialikara.com" target="_blank" rel="noopener noreferrer">H.Ali.K.</a>
        </p>
      </div>

      {/* Gündem Düzenleme Modalı */}
      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Gündem Düzenle</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {duzenlenecekGundem && (
            <Form>
              <Form.Group className="mb-3">
                <Form.Label>Başlık</Form.Label>
                <Form.Control 
                  value={duzenlenecekGundem.baslik} 
                  onChange={(e) => setDuzenlenecekGundem({...duzenlenecekGundem, baslik: e.target.value})} 
                  maxLength={MAX_BASLIK_UZUNLUK}
                />
                <small className="text-muted">{duzenlenecekGundem.baslik.length}/{MAX_BASLIK_UZUNLUK}</small>
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Branş</Form.Label>
                <Form.Control 
                  value={duzenlenecekGundem.brans || ""} 
                  onChange={(e) => setDuzenlenecekGundem({...duzenlenecekGundem, brans: e.target.value})} 
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Başlangıç Tarihi</Form.Label>
                <DatePicker 
                  className="form-control" 
                  selected={new Date(duzenlenecekGundem.baslangicTarihi)} 
                  onChange={(date) => setDuzenlenecekGundem({...duzenlenecekGundem, baslangicTarihi: date})} 
                  dateFormat="dd/MM/yyyy" 
                  wrapperClassName="w-100"
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Bitiş Tarihi</Form.Label>
                <DatePicker 
                  className="form-control" 
                  selected={new Date(duzenlenecekGundem.bitisTarihi)} 
                  onChange={(date) => setDuzenlenecekGundem({...duzenlenecekGundem, bitisTarihi: date})} 
                  dateFormat="dd/MM/yyyy" 
                  wrapperClassName="w-100"
                />
              </Form.Group>
              <Form.Group>
                <Form.Label>Not</Form.Label>
                <Form.Control 
                  as="textarea" 
                  rows={3} 
                  value={duzenlenecekGundem.not || ""} 
                  onChange={(e) => setDuzenlenecekGundem({...duzenlenecekGundem, not: e.target.value})} 
                />
              </Form.Group>
            </Form>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>Kapat</Button>
          <Button variant="primary" onClick={handleModalSave}>Kaydet</Button>
        </Modal.Footer>
      </Modal>

      {/* Not Gösterme Modalı */}
      <Modal show={showNotModal} onHide={() => setShowNotModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Not İçeriği</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {seciliNot || "Not içeriği bulunamadı"}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowNotModal(false)}>Kapat</Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default Gundemler;